import {makeAutoObservable, toJS} from 'mobx';

export class FamilyQuoteStore {
    selectedQuotes: any[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    toggleQuote(quote: any) {
        const index = this.selectedQuotes.findIndex((q) => q.id === quote.id);

        if (index > -1) {
            this.selectedQuotes.splice(index, 1);
        } else {
            this.selectedQuotes.push(quote);
        }
    }

    removeQuote(quote: any) {
        const index = this.selectedQuotes.findIndex((q) => q.id === quote.id);

        if (index > -1) {
            this.selectedQuotes.splice(index, 1);
        }
    }
}
